import { keepPreviousData, useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";

import { announcementsApi } from "@/api";
import type { CreateAnnouncementData } from "@/api";
import { QUERY_KEYS } from "@/constants";

export const useAudienceCounts = () =>
  useQuery({
    queryKey: [QUERY_KEYS.GET_AUDIENCE_COUNTS],
    queryFn: () => announcementsApi.audienceCounts(),
    select: res => res.data,
  });

export const useAnnouncements = (filter: { page?: number; limit?: number }) =>
  useQuery({
    queryKey: [QUERY_KEYS.GET_ANNOUNCEMENTS, filter],
    queryFn: () => announcementsApi.list(filter),
    placeholderData: keepPreviousData,
    select: res => ({ rows: res.data, meta: res.meta }),
  });

export const useCreateAnnouncement = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateAnnouncementData) => announcementsApi.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.GET_ANNOUNCEMENTS] });
    },
  });
};

/**
 * Yiqilgan (yoki `SENDING` da osilib qolgan) e'lonni qayta yuborish.
 *
 * Backend osilib qolgan yozuvni ham qabul qiladi: pod yetkazish o'rtasida
 * qayta ishga tushsa, qator hech qachon `FAILED` bo'lmaydi va admin uni
 * boshqa hech qanday yo'l bilan qo'zg'ata olmasdi.
 */
export const useRetryAnnouncement = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => announcementsApi.retry(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.GET_ANNOUNCEMENTS] });
      toast.success(t("ANNOUNCEMENTS.RETRY_TOAST"));
    },
  });
};
